module.exports = __webpack_public_path__ + "static/media/TheSeaKnowsmyName.0c411d92.jpg";